module.exports = __webpack_public_path__ + "static/media/server-connection.b420ab9c.svg";